if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class ProductInfoTabs extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.activate(trigger.dataset.tabTrigger));
        });
      }

      activate(key) {
        this.triggers.forEach((trigger) => {
          const isActive = trigger.dataset.tabTrigger === key;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive);
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.tabPanel !== key;
        });
      }
    }
  );
}
